import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

import type { RootState } from "../root/config.store";
import {
  type OrderDetailsList,
  OrderHistoryPayload,
  initialState,
} from "../../types/orderhistory";

// slice
export const orderHistorySlice = createSlice({
  name: "orderDetailsList",
  initialState,
  reducers: {
    fetchAllisLoading(state) {
      state.loading = true;
    },
    fetchAllSucceeded(state, action: PayloadAction<OrderDetailsList>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAllFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});




// Actions
export const orderHistoryActions = {
  fetchAll: createAction<OrderHistoryPayload>(
    `${orderHistorySlice.name}/fetchAll`
  ),
  fetchAllisLoading: orderHistorySlice.actions.fetchAllisLoading,
  fetchAllSucceeded: orderHistorySlice.actions.fetchAllSucceeded,
  fetchAllFailure: orderHistorySlice.actions.fetchAllFailure,
};

// Selectors
export const orderhistory = (state: RootState): OrderDetailsList =>
  state.orderDetailsList?.data ?? [];

// Reducer
export default orderHistorySlice.reducer;